import { createContext } from "react";

const announcementContext = createContext();

export default announcementContext;
